import { render, staticRenderFns } from "./PollResults.vue?vue&type=template&id=c29cea70&scoped=true&"
import script from "./PollResults.vue?vue&type=script&lang=js&"
export * from "./PollResults.vue?vue&type=script&lang=js&"
import style0 from "./PollResults.vue?vue&type=style&index=0&id=c29cea70&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29cea70",
  null
  
)

export default component.exports